import Vue from "vue";
import Router from "vue-router";
// import Explore from "./views/Explorer.vue";
import GeneralPage from "./components/core/General.vue";
import AddressPage from "./components/core/Address.vue";
import AddressDetailPage from "./components/core/AddressDetail.vue";
import TransactionPage from "./components/core/Transaction.vue";
import TransactionDetailPage from "./components/core/TransactionDetail.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/general",
      name: "general",
      component: GeneralPage
    },
    {
      path: "/address",
      name: "address",
      component: AddressPage
    },
    {
      path: "/address/:address",
      name: "addressDetail",
      component: AddressDetailPage
    },
    {
      path: "/transaction",
      name: "transaction",
      component: TransactionPage
    },
    {
      path: "/transaction/:transactionId",
      name: "transactionDetail",
      component: TransactionDetailPage
    },
    // {
    //   path: "/error",
    //   name: "error",
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () =>
    //     import(/* webpackChunkName: "about" */ "./views/Error.vue")
    // },
    { path: "*", redirect: "/general" }
  ]
});
